import React, { Fragment, useState } from 'react';
import { useNavigate } from 'react-router';
import {
    Row, Card, Badge
} from 'reactstrap';
import { H4, LI, P, Image, UL, Btn } from '../../../AbstractElements';
import errorImg from '../../../assets/images/search-not-found.png';
import { useSelector, useDispatch } from 'react-redux';
import { handleDelete } from 'Component/DashboardQeza/Common/DeleteUtils';
import { deleteBanner } from 'Services/Features/Banner/Utils/bannerUtils';
import { setFormData } from 'Services/Features/Banner/bannerSlice';
import Moment from 'react-moment';

const BannerContent = ({ setRefetch }) => {
    const banners = useSelector((state) => state.banner.banners);
    
    // const currentCategory = useSelector((state) => state.category.currentCategory);
    const dispatch = useDispatch();
    const layoutColumns = 3;
    const history = useNavigate();


    const handleEdit = (item) => {
        console.log(item, 'handleEditItem');
        // Simpan data photos dan banner ke state terpisah
        dispatch(setFormData({ photoLink: item.photo }));

        // Buat objek baru tanpa banner
        const { photo, ...updatedItem } = item;
        dispatch(setFormData({
            ...updatedItem,
        }));

        history(`${process.env.PUBLIC_URL}/banner/edit/${item.id}`);
    };




    return (
        <Fragment>
            <div className="product-wrapper-grid">
                <Row className="gridRow">
                    {banners && banners.map((item) => {
                        return (
                            <div id="gridId" className={`${layoutColumns === 3 ? 'col-xl-3 col-lg-6 col-sm-6 xl-4' : 'col-xl-' + layoutColumns}`} key={item.id}>
                                <Card >
                                    <div className="product-box">
                                        <div className="product-img" style={{ height: 'auto', overflow: 'hidden' }}>
                                            <Image attrImage={{ className: 'img-fluid w-100', src: item.photo ? item.photo : errorImg, alt: `${item.title}`, style: { height: '100%', objectFit: 'cover' } }} />
                                            <div className="product-hover">
                                                <UL attrUL={{ className: 'simple-list' }}>
                                                    <LI title="Delete" onClick={() => handleDelete(dispatch, item.id, setRefetch, deleteBanner)}><Btn attrBtn={{ color: 'transprant', type: 'button', datatoggle: 'modal', datatarget: '#exampleModalCenter' }}><i className="icon-trash"></i></Btn> </LI>
                                                </UL>
                                                <UL attrUL={{ className: 'simple-list' }}>
                                                    <LI title="Edit" onClick= {() => handleEdit(item)}><Btn attrBtn={{ color: 'transprant', type: 'button' }}><i className="icon-pencil-alt"></i></Btn></LI>
                                                </UL>
                                            </div>
                                        </div>
                                        <div className="product-details">
                                            <H4>
                                                <span title={item.title} style={{ cursor: 'default', color: 'inherit', textTransform: 'none'  }}>
                                                    {item.title && item.title.length > 23 ? `${item.title.substring(0, 23)}...` : item.title}
                                                </span>
                                            </H4>
                                            { item.link && (
                                            <P>
                                                <Badge color="primary" className="text-white" style={{ fontSize: '12px', cursor: 'pointer' }} onClick={() => window.open(item.link.startsWith('http') ? item.link : `http://${item.link}`, '_blank')}>
                                                    <i className="icon-link text-white"></i> {item.link}
                                                </Badge>
                                            </P>
                                            )}
                                            <P><i className="icon-alarm-clock me-2"></i> 
                                                <Moment format="DD MMM YYYY, hh:mm:ss">
                                                    {item.created_at}
                                                </Moment>
                                            </P>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                        );
                    })}
                </Row>
            </div>
        </Fragment>
    );
};
export default BannerContent;